import React from 'react'
import { FieldValues, Path, UseControllerProps } from 'react-hook-form'
import { Input } from '../Input'
import { DisplayNameInput } from './DisplayName'
import { Form } from './Form'
import { PasswordInput } from './Password'
import { FormattedMessage, useIntl } from 'react-intl'

type UserStepInputProps<T extends FieldValues> = Pick<
  UseControllerProps<T>,
  'control'
> & {
  onSubmit: React.FormEventHandler
  isValid: boolean
  displayName?: Path<T>
  password?: Path<T>
  email?: { value: string; hidden: boolean }
}

export function UserStepInput<T extends FieldValues>({
  onSubmit,
  isValid,
  control,
  displayName,
  password,
  email,
}: UserStepInputProps<T>) {
  const intl = useIntl()
  return (
    <form onSubmit={onSubmit} className="flexbox flexbox-column form-grid">
      {!!email?.hidden && (
        <div>
          <Form.Label>
            <FormattedMessage
              id="boarding.userStep.typeWorkEmail"
              defaultMessage="Your work email"
              values={{}}
            />
          </Form.Label>
          <Input
            hidden
            type="text"
            name="username"
            className="border-none"
            style={{ display: 'none' }}
            value={email.value}
            readOnly
          />
        </div>
      )}
      {!!displayName && (
        <div>
          <Form.Label>
            <FormattedMessage
              id="boarding.userStep.typeName"
              defaultMessage="Full name"
              values={{}}
            />
          </Form.Label>
          <DisplayNameInput<T> name={displayName} control={control} autoFocus />
        </div>
      )}
      {!!password && (
        <div>
          <Form.Label>
            <FormattedMessage
              id="boarding.userStep.choosePassword"
              defaultMessage="Choose a password"
              values={{}}
            />
          </Form.Label>
          <PasswordInput<T>
            name={password}
            control={control}
            hiddenEmail={email?.value}
            autoFocus={false}
          />
        </div>
      )}
      <Form.Button disabled={!isValid}>
        {intl.formatMessage({
          id: 'boarding.userStep.createAccount',
          defaultMessage: 'Create Account',
        })}
      </Form.Button>
    </form>
  )
}
